























































































































































































































































































































































































































































































import Vue from "vue";
import { getUserNickName } from "@/utils/labelUtils";
import VariableInput from "@/components/util/VariableInput.vue";
import ReturnTop from "@/parts/util/ReturnTop.vue";

import moment, { Moment } from "moment";

import { CodeBlock, ReviewComment } from "@/api/dto/CodeEditor";
import { DealResponse } from "@/api/dto/Deal";
import { getDeal } from "@/api/Deal";
import { ReviewEvaluation, UpdateReviewStatusRequest } from "@/api/dto/Review";
import { updateReviewStatus } from "@/api/Review";
import { UserProfile } from "@/api/dto/UserProfile";
import { defaultIconUrl } from "@/properties";
import axios from "axios";
import { ErrorResponse } from "@/api/dto/Error";

import hljs from "highlight.js";
import hljsCobol from "highlightjs-cobol";
import { genericExtension } from "@/properties";

hljs.registerLanguage("cobol", hljsCobol);

/**
 * 拡張子からhighlight.jsの言語名に変換
 * cf: <https://github.com/highlightjs/highlight.js/blob/main/SUPPORTED_LANGUAGES.md>
 */
const extensionToHljsLanguage = (ext: string): string => {
  if (genericExtension.includes(ext)) {
    return "plaintext";
  }
  switch (ext) {
    case "cob":
      return "cobol";
    case "exs":
      return "elixir";
    case "asm":
      return "x86asm";
    case "bas":
      return "basic";
    default:
      return ext;
  }
};

export default Vue.extend({
  name: "Deal",
  components: {
    VariableInput,
    ReturnTop,
  },
  props: {
    mq: String,
  },
  data() {
    return {
      dealData: {} as DealResponse,
      progress: [
        {
          user: "order",
          value: [
            { dealStatus: "3", text: "1  レビュー" },
            { dealStatus: "4", text: "2  確認・質問" },
            { dealStatus: "5", text: "3  取引終了" },
          ],
        },
        {
          user: "purchase",
          value: [
            { dealStatus: "3", text: "1  レビュー" },
            { dealStatus: "4", text: "2  確認・評価" },
            { dealStatus: "5", text: "3  取引終了" },
          ],
        },
      ],
      progressMessage: [
        {
          user: "order",
          value: [
            { dealStatus: "3", text: "受注しました！さっそくコードレビューをして、コメントを送信してください。" },
            { dealStatus: "4", text: "依頼者がレビューを確認しています。質問か評価の通知をお待ちください。" },
            { dealStatus: "5", text: "依頼者から評価がつきました。取引はこれで終了です。" },
          ],
        },
        {
          user: "purchase",
          value: [
            { dealStatus: "3", text: "受注者がレビューしています。コメントをお待ちください。" },
            { dealStatus: "4", text: "受注者がレビューを完了しました。内容を確認後、評価を送信してください。" },
            { dealStatus: "5", text: "評価を送信しました。取引はこれで終了です。" },
          ],
        },
      ],
      periodTimeReview: "",
      timerReview: 0,
      periodTimeAnswer: "",
      timerAnswer: 0,
      periodTimeEvaluation: "",
      timerEvaluation: 0,
      mode: "comment",
      tabs: [
        { mode: "comment", text: "コメント" },
        { mode: "code", text: "コード" },
      ],
      reaction: [
        { id: "smiley", src: "/images/deal/emoji_1.svg" },
        { id: "shy", src: "/images/deal/emoji_2.svg" },
        { id: "hmm", src: "/images/deal/emoji_3.svg" },
        { id: "cry", src: "/images/deal/emoji_4.svg" },
        { id: "applause", src: "/images/deal/emoji_5.svg" },
        { id: "ok", src: "/images/deal/emoji_6.svg" },
      ],
      reactionOpen: {} as { [key: number]: boolean },
      commentInput: "",
      codeLineStatus: {} as { [key: string]: any },
      codeLineIndex: 0,
      codeCommentTriggerStyle: {
        display: "flex",
        top: "0",
      },
      modalOpen: false,
      startOpen: false,
      cancelOpen: false,
      evaluationOpen: false,
      evaluationList: [
        { value: "1", text: "良い" },
        { value: "2", text: "悪い" },
        { value: "3", text: "評価なし" },
      ],
      evaluation: "1" as ReviewEvaluation,
      getUserNickName,
    };
  },
  async beforeRouteEnter(to, from, next) {
    try {
      const res = await getDeal(to.params.dealId);
      next((vm) => (vm.$data.dealData = res));
    } catch (e) {
      console.log(e);
    }
  },
  created() {
    this.initData(this.$route.params.dealId);
  },
  destroyed() {
    this.clearLimitTime();
  },
  computed: {
    loginData(): UserProfile {
      return this.$store.getters.userProfile;
    },
    progressHeader(): { dealStatus: string; text: string }[] {
      if (Object.keys(this.dealData).length) {
        var user = this.dealData.orderUserId == this.loginData.userId ? "order" : "purchase";
        var returnArray1 = this.progress.filter((v) => v.user == user)[0];
        return returnArray1.value;
      } else {
        // async/awaitを待たずに実行するため、undefindが返ってくる対策
        return [];
      }
    },
    messageHeader(): string {
      if (Object.keys(this.dealData).length) {
        var user = this.dealData.orderUserId == this.loginData.userId ? "order" : "purchase";
        var returnArray1 = this.progressMessage.filter((v) => v.user == user)[0];
        var returnArray2 = returnArray1.value.filter((v) => v.dealStatus == this.dealData.dealStatus)[0];
        if (returnArray2.dealStatus == "3" && this.dealData.dealStartTime == "") {
          if (this.dealData.orderUserId == this.loginData.userId) {
            return "入札した依頼の受注者に選ばれました。取引を開始してください。";
          } else {
            return "受注者による取引開始をお待ちください。";
          }
        }
        return returnArray2.text;
      } else {
        // async/awaitを待たずに実行するため、undefindが返ってくる対策
        return "";
      }
    },
    isAnswer(): boolean {
      var lastReviewComment = this.dealData.reviewComment.slice(-1)[0];
      if (lastReviewComment.userId == this.dealData.purchaseUserId) {
        return true;
      } else {
        return false;
      }
    },
    countComment(): number {
      if (Object.keys(this.dealData).length) {
        return this.dealData.reviewComment.length;
      } else {
        // async/awaitを待たずに実行するため、undefindが返ってくる対策
        return 0;
      }
    },
    countCodeComment(): number {
      if (Object.keys(this.dealData).length) {
        return this.dealData.reviewComment.filter((v) => v.codeBlock.fileName).length;
      } else {
        // async/awaitを待たずに実行するため、undefindが返ってくる対策
        return 0;
      }
    },
    targetCodeAbstract: function () {
      var codeEditor = this.dealData.codeEditor;
      return function (target: CodeBlock) {
        var codeText = codeEditor.filter((v) => v.fileName + v.extension == target.fileName)[0].text;
        var codeTextLength = codeText.length;
        var firstIndex;
        var lastIndex;
        if (codeTextLength <= 3) {
          firstIndex = 0;
          lastIndex = codeTextLength;
        } else {
          if (target.line < 2) {
            firstIndex = 0;
            lastIndex = 3;
          } else if (codeTextLength - 1 < target.line) {
            firstIndex = codeTextLength - 3;
            lastIndex = codeTextLength;
          } else {
            firstIndex = target.line - 2;
            lastIndex = target.line + 1;
          }
        }
        return codeText.slice(firstIndex, lastIndex);
      };
    },
    countResidueComment(): number {
      var countResidue = 3;
      if (this.dealData.purchaseType == "1" && this.dealData.questionLimitType == "1") {
        countResidue = this.dealData.questionLimitCount;
      }
      return countResidue - this.dealData.reviewComment.filter((v) => v.userId === this.dealData.purchaseUserId).length;
    },
    isPendingReview(): boolean {
      if (this.dealData.dealStartTime == "") {
        return true;
      } else {
        return false;
      }
    },
  },
  watch: {
    mq() {
      if (this.mq != "sp") {
        for (var i in this.reactionOpen) {
          this.reactionOpen[i] = false;
        }
      }
    },
  },
  methods: {
    async initData(dealId: string) {
      // 取引情報取得
      try {
        const res = await getDeal(dealId);
        var access = false;
        // 依頼者||受注者がログイン者である&&（取引ステータスがレビュー中||確認||完了である）
        if (
          (res.purchaseUserId == this.loginData.userId || res.orderUserId == this.loginData.userId) &&
          (res.dealStatus == "3" || res.dealStatus == "4" || res.dealStatus == "5")
        ) {
          access = true;
        }
        if (access) {
          this.dealData = res;
          this.initSet();
        } else {
          this.$router.replace({ name: "Top" });
        }
      } catch (e) {
        console.log(e);
        this.$router.replace({ name: "Top" });
      }
    },
    initSet() {
      this.setIconDefalt();
      this.setLimitTime();
      this.setCodeEditorComment();
    },
    // アイコン画像がない場合、デフォルト画像切り替え
    setIconDefalt() {
      if (!this.dealData.orderIconUrl) {
        this.dealData.orderIconUrl = defaultIconUrl;
      }
      if (!this.dealData.purchaseIconUrl) {
        this.dealData.purchaseIconUrl = defaultIconUrl;
      }
    },
    // 制限時間のインターバル破棄
    clearLimitTime() {
      clearInterval(this.timerReview); // レビュー制限時間のインターバル解除
      clearInterval(this.timerAnswer); // 回答制限時間のインターバル解除
      clearInterval(this.timerEvaluation); // 評価制限時間のインターバル解除
    },
    // 制限時間のインターバル初期設定
    setLimitTime() {
      this.clearLimitTime();
      if (this.dealData.dealStatus == "3" && this.dealData.orderUserId == this.loginData.userId) {
        // レビュー制限時間のインターバル設定
        this.timerReview = setInterval(this.countDownReview, 1000);
      } else if (
        this.dealData.dealStatus == "4" &&
        this.dealData.orderUserId == this.loginData.userId &&
        this.isAnswer
      ) {
        // 回答制限時間のインターバル設定
        this.timerAnswer = setInterval(this.countDownAnswer, 1000);
      } else if (
        this.dealData.dealStatus == "4" &&
        this.dealData.purchaseUserId == this.loginData.userId &&
        !this.isAnswer
      ) {
        // 評価制限時間のインターバル設定
        this.timerEvaluation = setInterval(this.countDownEvaluation, 1000);
      }
    },
    // レビューコメントを基にコードエディターのコメント設置
    setCodeEditorComment() {
      let codeEditor = this.dealData.codeEditor;
      let reviewComment = this.dealData.reviewComment;
      for (var i = 0; i < reviewComment.length; i++) {
        if (reviewComment[i].codeBlock.fileName) {
          for (var j = 0; j < codeEditor.length; j++) {
            if (codeEditor[j].fileName + codeEditor[j].extension == reviewComment[i].codeBlock.fileName) {
              var index = reviewComment[i].codeBlock.line - 1;
              var text = reviewComment[i].text;
              var time = reviewComment[i].postTime;
              this.$set(this.codeLineStatus, "commentFix-" + j + "-" + index, true);
              this.$set(this.codeLineStatus, "commentInput-" + j + "-" + index, text);
              this.$set(this.codeLineStatus, "commentTime-" + j + "-" + index, time);
              break;
            }
          }
        }
      }
    },
    countDown(limitTime: Moment) {
      var diff = limitTime.diff(moment()) + 1000; // 差をミリ秒で取得
      var duration = moment.duration(diff); // ミリ秒からdurationオブジェクトを生成
      var days = Math.floor(duration.asDays());
      var hours = duration.hours();
      var minutes = duration.minutes();
      var seconds = duration.seconds();
      if (days > 0) {
        return days + "日以上";
      } else if (hours > 0) {
        return hours + "時間" + minutes + "分";
      } else if (minutes > 0) {
        return minutes + "分" + seconds + "秒";
      } else if (seconds > 0) {
        return seconds + "秒";
      } else {
        return;
      }
    },
    countDownReview() {
      var result = this.countDown(moment(this.dealData.dealStartTime).add(48, "hours"));
      if (result) {
        this.periodTimeReview = result;
      } else {
        clearInterval(this.timerReview); // レビュー制限時間のインターバル解除
        this.periodTimeReview = 0 + "秒";
        this.cancelExct(true);
      }
    },
    countDownAnswer() {
      var lastReviewComment = this.dealData.reviewComment.slice(-1)[0];
      var result = this.countDown(moment(lastReviewComment.postTime).add(7, "days"));
      if (result) {
        this.periodTimeAnswer = result;
      } else {
        clearInterval(this.timerAnswer); // 回答制限時間のインターバル解除
        this.periodTimeAnswer = 0 + "秒";
        this.evaluationExct(true);
      }
    },
    countDownEvaluation() {
      var lastReviewComment = this.dealData.reviewComment.slice(-1)[0];
      var result = this.countDown(moment(lastReviewComment.postTime).add(7, "days"));
      if (result) {
        this.periodTimeEvaluation = result;
      } else {
        clearInterval(this.timerEvaluation); // 評価制限時間のインターバル解除
        this.periodTimeEvaluation = 0 + "秒";
        this.evaluationExct(true);
      }
    },
    changeMode(key: string) {
      this.mode = key;
    },
    reactionOver(key: number) {
      if (this.mq != "sp") {
        this.$set(this.reactionOpen, key, true);
      }
    },
    reactionLeave(key: number) {
      if (this.mq != "sp") {
        this.$set(this.reactionOpen, key, false);
      }
    },
    reactionToggle(key: number) {
      this.$set(this.reactionOpen, key, !this.reactionOpen[key]);
    },
    reacionOff(key: number) {
      this.reacionSbumit();
      this.$set(this.reactionOpen, key, false);
    },
    async reacionSbumit() {
      var req: UpdateReviewStatusRequest = {
        dealStatus: this.dealData.dealStatus,
        reviewComment: this.dealData.reviewComment,
      };
      try {
        var res = await updateReviewStatus(this.dealData.dealId, req);
        this.dealData = res;
        this.initSet();
      } catch (e) {
        console.log(e);
      }
    },
    async commentSbumit() {
      if (this.commentInput) {
        let reviewComment: ReviewComment = {
          userId: this.loginData.userId,
          codeBlock: {
            fileName: "",
            line: 0,
          },
          text: this.commentInput,
          postTime: new Date(),
          reactionMark: [0, 0, 0, 0, 0, 0],
        };
        let reviewComments = this.dealData.reviewComment.concat();
        reviewComments.push(reviewComment);

        let commentUserId = "";
        if (this.dealData.orderUserId == this.loginData.userId) {
          commentUserId = this.dealData.orderUserId;
        }

        let dealStatus = this.dealData.dealStatus
        if (this.dealData.dealStatus == '3') {
          // 初回のコメントの場合は、ステータスをレビュー中→確認に更新
          dealStatus = '4'
        }

        var req: UpdateReviewStatusRequest = {
          dealStatus: dealStatus,
          reviewComment: reviewComments,
          orderUserId: commentUserId,
        };
        try {
          var res = await updateReviewStatus(this.dealData.dealId, req);
          this.dealData = res;
          this.initSet();
          this.commentInput = "";
          this.$emit("toast", "コメントを登録しました");
        } catch (e) {
          console.log(e);
          if (axios.isAxiosError(e) && e.response) {
            var resError = e.response.data as ErrorResponse;
            if (resError.message == null) {
              this.$emit("errorToast", "コメント登録に失敗しました。しばらく経ってからやり直してください。");
            } else {
              this.$emit("errorToast", resError.message);
            }
          }
        }
      }
    },
    codeLineOver(key: number, index: number, event: Event) {
      if (!this.codeLineStatus["commentFix-" + key + "-" + index]) {
        this.$set(this.codeLineStatus, "line-" + key + "-" + index, true);
        this.$set(this.codeLineStatus, "commentTrigger-" + key + "-" + index, true);
        this.codeLineIndex = index;
        let targetElement = event.target as HTMLElement;
        let targetTop = targetElement.getBoundingClientRect().top;
        let parentElement = targetElement.closest(".editorwrap-ex") as HTMLElement;
        let parentTop = parentElement.getBoundingClientRect().top;
        this.codeCommentTriggerStyle.top = targetTop - parentTop - 1 + "px";
      }
    },
    codeLineLeave(key: number, index: number) {
      this.$set(this.codeLineStatus, "line-" + key + "-" + index, false);
      this.$set(this.codeLineStatus, "commentTrigger-" + key + "-" + index, false);
    },
    codeCommentTriggerOver(key: number, index: number) {
      this.$set(this.codeLineStatus, "line-" + key + "-" + index, true);
      this.$set(this.codeLineStatus, "commentTrigger-" + key + "-" + index, true);
    },
    codeCommentTriggerLeave(key: number, index: number) {
      this.codeLineLeave(key, index);
    },
    codeCommentShowToggle(key: number, index: number) {
      this.$set(
        this.codeLineStatus,
        "comment-" + key + "-" + index,
        !this.codeLineStatus["comment-" + key + "-" + index]
      );
      if (!this.codeLineStatus["comment-" + key + "-" + index]) {
        this.$set(this.codeLineStatus, "commentInput-" + key + "-" + index, "");
      }
    },
    codeCommentShowHidden(key: number, index: number) {
      this.$set(this.codeLineStatus, "comment-" + key + "-" + index, false);
      this.$set(this.codeLineStatus, "commentInput-" + key + "-" + index, "");
    },
    async codeCommentRegist(key: number, index: number) {
      if (this.codeLineStatus["commentInput-" + key + "-" + index]) {
        let reviewComment: ReviewComment = {
          userId: this.loginData.userId,
          codeBlock: {
            fileName: this.dealData.codeEditor[key].fileName + this.dealData.codeEditor[key].extension,
            line: index + 1,
          },
          text: this.codeLineStatus["commentInput-" + key + "-" + index],
          postTime: new Date(),
          reactionMark: [0, 0, 0, 0, 0, 0],
        };
        let reviewComments = this.dealData.reviewComment.concat();
        reviewComments.push(reviewComment);

        let commentUserId = "";
        if (this.dealData.orderUserId == this.loginData.userId) {
          commentUserId = this.dealData.orderUserId;
        }

        let dealStatus = this.dealData.dealStatus
        if (this.dealData.dealStatus == '3') {
          // 初回のコメントの場合は、ステータスをレビュー中→確認に更新
          dealStatus = '4'
        }

        var req: UpdateReviewStatusRequest = {
          dealStatus: dealStatus,
          reviewComment: reviewComments,
          orderUserId: commentUserId,
        };
        try {
          var res = await updateReviewStatus(this.dealData.dealId, req);
          this.dealData = res;
          this.initSet();
          this.$set(this.codeLineStatus, "comment-" + key + "-" + index, false);
          this.$emit("toast", "コメントを登録しました");
        } catch (e) {
          console.log(e);
          if (axios.isAxiosError(e) && e.response) {
            var resError = e.response.data as ErrorResponse;
            if (resError.message == null) {
              this.$emit("errorToast", "コメント登録に失敗しました。しばらく経ってからやり直してください。");
            } else {
              this.$emit("errorToast", resError.message);
            }
          }
        }
      }
    },
    scrollToAnchorPoint(mode: string, refName: string) {
      this.mode = mode;
      let toElement = this.$refs[refName] as HTMLElement;
      setTimeout(function () {
        // タブ切り替えた後にスクロールできない対策
        toElement.scrollIntoView({ behavior: "smooth", block: "center" });
      }, 0);
    },
    startModalOpen() {
      this.modalOpen = true;
      this.startOpen = true;
    },
    cancelModalOpen() {
      this.modalOpen = true;
      this.cancelOpen = true;
    },
    evaluationModalOpen() {
      this.modalOpen = true;
      this.evaluationOpen = true;
    },
    modalClose() {
      this.modalOpen = false;
      this.startOpen = false;
      this.cancelOpen = false;
      this.evaluationOpen = false;
    },
    async startExct() {
      var req: UpdateReviewStatusRequest = {
        dealStatus: "3",
      };
      try {
        var res = await updateReviewStatus(this.dealData.dealId, req);
        this.dealData = res;
        this.initSet();
      } catch (e) {
        console.log(e);
        this.$emit("errorToast", "レビューの開始に失敗しました。しばらく経ってからやり直してください。");
      } finally {
        this.modalClose();
      }
    },
    async cancelExct(autoExct: boolean) {
      var req: UpdateReviewStatusRequest = {
        dealStatus: "2",
        orderUserId: this.dealData.orderUserId,
      };
      if (!autoExct) {
        // 受注をキャンセルするボタンを押下
        try {
          await updateReviewStatus(this.dealData.dealId, req);
          this.$emit("pushPath", this.$router.push({ name: "DealsManagement" }));
        } catch (e) {
          console.log(e);
          this.$emit("errorToast", "受注キャンセルに失敗しました。しばらく経ってからやり直してください。");
        }
      } else if (this.dealData.dealStartTime != "") {
        // 自動的に受注をキャンセル
        try {
          await updateReviewStatus(this.dealData.dealId, req);
        } catch (e) {
          console.log(e);
        } finally {
          this.$emit("toast", "受注から48時間を過ぎました。自動に受注をキャンセルにしました。");
          this.$emit("pushPath", this.$router.push({ name: "DealsManagement" }));
        }
      }
    },
    async evaluationExct(autoExct: boolean) {
      if (!autoExct) {
        var evaluation = this.evaluation;
      } else {
        var evaluation = "3" as ReviewEvaluation; // 期限を過ぎたら評価なし
      }
      var req: UpdateReviewStatusRequest = {
        dealStatus: "5",
        evaluation: evaluation,
      };
      try {
        var res = await updateReviewStatus(this.dealData.dealId, req);
        this.dealData = res;
        this.initSet();
      } catch (e) {
        console.log(e);
        if (!autoExct) {
          this.$emit("errorToast", "評価の送信に失敗しました。しばらく経ってからやり直してください。");
        }
      } finally {
        this.modalClose();
      }
    },
    lineHtmls(code: string, ext: string) {
      const { value } = hljs.highlight(code, {
        language: extensionToHljsLanguage(ext.slice(1)),
      });
      return value;
    },
    getExtension(fileName: string) {
      var ext = "";
      Array.prototype.forEach.call(this.dealData.codeEditor, (item) => {
        var name = item.fileName + item.extension;
        if (ext === "" && name === fileName) {
          ext = item.extension;
        }
      });
      return ext;
    },
  },
  filters: {
    fileNameOthersHide: function (fileName: string) {
      return fileName.replace(/その他$/, "");
    },
    amountLocaleString: function (amount: number) {
      if (amount) {
        return amount.toLocaleString();
      } else {
        // async/awaitを待たずに実行するため、undefindが返ってくる対策
        return amount;
      }
    },
    timeDiff: function (date: Date) {
      moment.locale("ja");
      return moment(date).fromNow();
    },
  },
});
